import React, { useState, useRef, useEffect } from "react";
import { Box, Button } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import FlexBox from "../../components/FlexBox";
import LightTextField from "../../components/LightTextField";
import { FC } from "react";
import { getUserInfo } from "../../redux/actions/UserAction";
import { load, remove, save } from "../../constants/storage";
import * as Models from "../../models";
import { H3, H4 } from "../../components/Typography";
import { maxPANLength, maxIFSCLength } from "../../common/common";

import {
  verifyPAN,
  verifyIFSC,
  verifyBankMutualFund,
} from "../../redux/actions/KYCAction";
import { useAppDispatch } from "../../store/hooks";
import {
  VerifyPANRequest,
  VerifyIFSC,
  VerifyBankDetailMutualFundRequest,
} from "models";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
interface FirstStepProps {
  onPress: any;
}
type FormValues = {
  pan: string;
  ifsc_code: string;
  bank_name: string;
  acc_number: string;
  accholders_name: string;
  account_type: string;
  upi: string;
};

type FormErrors = {
  pan?: string;
  ifsc_code?: string;
  bank_name?: string;
  acc_number?: string;
  accholders_name?: string;
  account_type?: string;
  upi?: string;
};

const KYCInformation: FC<FirstStepProps> = ({ onPress }) => {
  const [formValues, setFormValues] = useState<FormValues>({
    pan: "",
    ifsc_code: "",
    bank_name: "",
    acc_number: "",
    accholders_name: "",
    account_type: "",
    upi: "",
  });

  const [formErrors, setFormErrors] = useState<FormErrors>({});
  const [panVerified, setPanVerified] = useState(true);
  const [compliance, setCompliance] = useState(false);
  const [userInfo, setuserInfo] = useState<any>();
  let navigate = useNavigate();
  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
    setFormErrors({ ...formErrors, [name]: "" }); // clear any previous errors for this field
  }
  const dispatch = useAppDispatch();
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    checkToken();
  }, []);

  const checkToken = async () => {
    let token = await load("token");
    if (token === undefined) {
      remove("userData");
      remove("token");
      toast.success("Session expired, please login again.");
      navigate("/login");
    } else {
      let userDetail: any = load("userData");
      let finalUser = JSON.parse(userDetail);
      setuserInfo(finalUser);
      getUserInfomation(finalUser);
    }
  };

  const getUserInfomation = async (userDetails: any) => {
    let token = load("token");
    const req: Models.GETUSER_INFO_REQUEST = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      source: "web",
    };

    dispatch(getUserInfo(req, `bearer ${token}`))
      .then(async (response: any) => {
        await save("userData", JSON.stringify(response?.data[0]));
        setFormValues(response?.data[0]);
        if (!response?.data[0].pan) {
          setFormValues((prevState) => ({
            ...prevState,
            pan: response?.data[0].pan,
          }));
          onhandleBlur();
        }
        setFormValues((prevState) => ({
          ...prevState,
          accholders_name: userDetails.accholders_name
            ? userDetails.accholders_name
            : userDetails?.firstname + " " + userDetails?.lastname,
        }));
      })
      .catch((error: any) => {
        alert(`Error: ${error?.code} | ${error?.description}`);
      });
  };

  const onhandleBlur = async () => {
    let token = load("token");

    const data: VerifyPANRequest = {
      id: userInfo.id,
      mobile: userInfo.mobile,
      pan: formValues.pan,
      partner: userInfo.refcode,
    };
    dispatch(verifyPAN(data, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.message === "PAN number Validated Successfully") {
          setPanVerified(false);
          setFormValues((prevState) => ({
            ...prevState,
            pan: formValues.pan,
          }));
          if (response.data[0].kyc_verified === true) {
            setCompliance(true);
            await save("PANVerify", true);
          } else {
            setCompliance(false);
            await save("PANVerify", false);
          }

          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const onhandleIFSCBlur = async () => {
    let token = load("token");

    const data: VerifyIFSC = {
      id: userInfo.id,
      mobile: userInfo.mobile,
      ifsc: formValues.ifsc_code,
      partner: userInfo.refcode,
    };
    dispatch(verifyIFSC(data, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.message === "Fetched Bank details Successfully") {
          setFormValues((prevState) => ({
            ...prevState,
            bank_name: response.bankdata.bank_name,
          }));
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      })
      .catch((error: any) => {
        console.log("----------verifyIFSC--------------", error);
      });
  };

  const handleResidentalStatus = (event: SelectChangeEvent) => {
    setFormValues((prevState) => ({
      ...prevState,
      account_type: event.target.value,
    }));
  };

  function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const newErrors: FormErrors = {};
    const regex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
    if (!regex.test(formValues.pan)) {
      newErrors.pan = "Please enter a valid PAN number.";
    }
    if (!(formValues.pan && formValues.pan.length == 10)) {
      newErrors.pan = "Please enter a valid PAN Number";
    }
    if (!formValues.pan) {
      newErrors.pan = "PAN number is required";
    }
    if (panVerified === false) {
      let ifscCodeRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
      if (!ifscCodeRegex.test(formValues.ifsc_code)) {
        newErrors.ifsc_code = "Please enter a valid IFSC code.";
      }
      if (!(formValues.ifsc_code && formValues.ifsc_code?.length <= 11)) {
        newErrors.ifsc_code = "Please enter a valid IFSC code.";
      }
      if (!formValues.ifsc_code) {
        newErrors.ifsc_code = "IFSC code is required";
      }
      if (!formValues.bank_name) {
        newErrors.bank_name = "Bank name is required";
      }
      if (!formValues.acc_number) {
        newErrors.acc_number = "Account Number is required";
      }
      if (!(formValues?.acc_number && formValues.acc_number?.length > 9)) {
        newErrors.acc_number = "Please enter a valid Account Number";
      }
      let bankRegex = /^[0-9]*$/;
      if (!bankRegex.test(formValues.acc_number)) {
        newErrors.acc_number = "Account Number must contain only numbers";
      }
      if (!formValues.accholders_name) {
        newErrors.accholders_name = "Account holder name is required";
      }
      if (!formValues.upi) {
        newErrors.upi = "UPI ID name is required";
      }
    }

    // if there are errors, update state with them
    if (Object.keys(newErrors).length > 0) {
      setFormErrors(newErrors);
    } else {
      verifyBankAccont();
    }
  }

  const verifyBankAccont = async () => {
    const accHoldersName = formValues.accholders_name
      .replace(/\s+/g, " ")
      .trim();
    let token = load("token");
    const req: VerifyBankDetailMutualFundRequest = {
      id: userInfo?.id,
      mobile: userInfo?.mobile,
      partner: userInfo?.refcode,
      ifsc: formValues.ifsc_code.toUpperCase(),
      bank_name: formValues.bank_name,
      upi: formValues.upi,
      account_type: formValues.account_type,
      account_holder_name: accHoldersName,
      account_number: formValues.acc_number,
      branch_name: formValues.bank_name,
    };
    dispatch(verifyBankMutualFund(req, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.error) {
          toast.error(response?.message);
          return;
        }
        onPress(formValues, compliance);
        await getUserInfomation(userInfo);
      })
      .catch((error: any) => {
        console.log("login__error", error);
      });
  };
  return (
    <form onSubmit={handleSubmit}>
      <H3 sx={headingText}>Bank Details</H3>
      <FlexBox
        justifyContent="space-between"
        flexWrap="wrap"
        flexDirection={"row"}
      >
        <LightTextField
          name="pan"
          label="PAN Number"
          sx={textInputStyles}
          onBlur={onhandleBlur}
          value={formValues.pan ? formValues.pan : ""}
          error={!!formErrors.pan}
          helperText={formErrors.pan}
          onChange={handleChange}
          inputProps={{
            maxLength: maxPANLength,
          }}
          inputRef={inputRef}
        />
        <LightTextField
          disabled={panVerified}
          name="ifsc_code"
          label="IFSC Code"
          onBlur={onhandleIFSCBlur}
          sx={textInputStyles}
          inputProps={{
            maxLength: maxIFSCLength,
          }}
          value={formValues.ifsc_code ? formValues.ifsc_code : ""}
          onChange={handleChange}
          error={!!formErrors.ifsc_code}
          helperText={formErrors.ifsc_code}
        />
      </FlexBox>
      <FlexBox flexWrap="wrap" sx={rowContainer}>
        <LightTextField
          disabled
          name="bank_name"
          label="Bank Name"
          sx={textInputStyles}
          value={formValues.bank_name ? formValues.bank_name : ""}
          onChange={handleChange}
          error={!!formErrors.bank_name}
          helperText={formErrors.bank_name}
        />
        <LightTextField
          disabled={panVerified}
          name="acc_number"
          label="Account Number"
          sx={textInputStyles}
          value={formValues.acc_number ? formValues.acc_number : ""}
          onChange={handleChange}
          error={!!formErrors.acc_number}
          helperText={formErrors.acc_number}
        />
      </FlexBox>
      <FlexBox sx={rowContainer}>
        <LightTextField
          disabled={panVerified}
          name="accholders_name"
          label="Account Holder Name"
          sx={textInputStyles}
          value={formValues.accholders_name ? formValues.accholders_name : ""}
          onChange={handleChange}
          error={!!formErrors.accholders_name}
          helperText={formErrors.accholders_name}
        />
        <Select
          sx={selectedView}
          value={formValues.account_type ? formValues.account_type : ""}
          required
          disabled={panVerified}
          onChange={handleResidentalStatus}
          displayEmpty
          inputProps={{ "aria-label": "Without label" }}
          renderValue={(selected) => {
            if (selected.length === 0) {
              return <H4 style={{ color: "#C0C0C0" }}>Account Type</H4>;
            }
            return selected;
          }}
        >
          <MenuItem disabled value="">
            <H4>Account Type</H4>
          </MenuItem>
          <MenuItem value={"SAVINGS"}>SAVINGS</MenuItem>
          <MenuItem value={"CURRENT"}>CURRENT</MenuItem>
        </Select>
      </FlexBox>
      <FlexBox sx={rowContainer} marginBottom={2}>
        <LightTextField
          disabled={panVerified}
          name="upi"
          label="UPI ID"
          sx={textInputStyles}
          value={formValues.upi ? formValues.upi : ""}
          onChange={handleChange}
          error={!!formErrors.upi}
          helperText={formErrors.upi}
        />
      </FlexBox>

      <Box sx={sxStyleBox2}>
        <Button
          onClick={() => navigate(-1)}
          variant="contained"
          size="medium"
          sx={{
            mt: 3,
            mb: 2,
            py: 1,
            fontFamily: "'Poppins', sans-serif",
            width: {
              xs: "100%",
              sm: "100%",
              md: "40%",
            },
            alignSelf: "center",
            background: "#FFF5D1",
            color: process.env.REACT_APP_PRIMARY_COLOR,
            fontSize: "16px",
            fontWeight: "600",
          }}
        >
          Back
        </Button>
        <Button
          type="submit"
          variant="contained"
          size="medium"
          sx={{
            mt: 3,
            mb: 2,
            py: 1,
            fontFamily: "'Poppins', sans-serif",
            width: {
              xs: "100%",
              sm: "100%",
              md: "40%",
            },
            alignSelf: "center",
            background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
          }}
          // onClick={() => handleSubmit()}
        >
          Next
        </Button>
      </Box>
    </form>
  );
};

export default KYCInformation;
const headingText = {
  mt: 3,
  textAlign: "left",
  fontFamily: "'Poppins', sans-serif",
};
const textInputStyles = {
  width: {
    xs: "100%",
    sm: "100%",
    md: "49%",
  },
  marginTop: {
    xs: 2,
    sm: 2,
    md: 2,
  },
};

const rowContainer = {
  flexDirection: {
    xs: "column",
    sm: "column",
    md: "row",
  },
  justifyContent: "space-between",
};
const selectedView = {
  width: {
    xs: "100%",
    sm: "100%",
    md: "49%",
  },
  marginTop: {
    xs: 2,
    sm: 2,
    md: 2,
  },
  height: 55,
  fontFamily: "'Poppins', sans-serif",
};

const sxStyleBox2 = {
  alignItems: "center",
  justifyContent: "space-around",
  flexDirection: {
    xs: "column",
    sm: "column",
    md: "row",
  },
  display: "flex",
  mt: 2,
};
